import { render, staticRenderFns } from "./TaskDirections.vue?vue&type=template&id=456c0ff5&"
import script from "./TaskDirections.vue?vue&type=script&lang=js&"
export * from "./TaskDirections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports